import LoyaltyEarlyAccessSaleBanner from "../../containers/EarlyAccessSale";
import addLoyaltyBanner from "../../helpers/addLoyaltyBanner";

const addLoyaltyEarlyAccessSaleBanner = ({
  viewportCategory,
  positionFinder,
  items
}) =>
  addLoyaltyBanner({
    viewportCategory,
    positionFinder,
    items,
    BannerComponent: (
      <LoyaltyEarlyAccessSaleBanner key="loyaltyEarlyAccessSaleBanner" />
    )
  });

export default addLoyaltyEarlyAccessSaleBanner;
